const { Stack, Typography, Tooltip } = require('@mui/material');

const HEX_COLOR_PATTERN = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

const PlayerNames = ({ team }) => {
  const useTeamName = team.name !== 'Team 1' && team.name !== 'Team 2' && team.name;
  const groupColor = team?.groupColor || team?.group?.color;
  const explicitColor = HEX_COLOR_PATTERN.test(groupColor || '')
    ? groupColor
    : HEX_COLOR_PATTERN.test(team?.color || '')
      ? team.color
      : null;

  const borderColor = explicitColor || (team?.color ? `${team.color}.main` : 'divider');

  return (
    <Stack
      sx={{
        border: '3px solid',
        borderColor,
        borderRadius: 2,
        p: { xs: 1.5, sm: 3 },
        minWidth: 0,
        maxWidth: '100%'
      }}>
      {!useTeamName ? (
        team.players?.map((player, index) => (
          <Typography key={index} variant="caption">
            {player.length > 10 ? `${player.substring(0, 10)}...` : player}{' '}
          </Typography>
        ))
      ) : (
        <Tooltip title={team.players?.join(', ')}>
          <Typography variant="caption" textAlign="center" sx={{ overflowWrap: 'anywhere' }}>
            {team.name}
          </Typography>
        </Tooltip>
      )}
    </Stack>
  );
};

export default PlayerNames;
